export default {
  translation: {
    shopButton: 'Ajouter au panier',
    buttonsHeader: 'Achetez des ingrédients en ligne',
    unavailableTitle: 'Pour le moment, nous ne livrons pas les ingrédients à votre adresse. Trouvez des magasins physiques près de chez vous pour acheter nos produits.',
    unavailableButtonLabel: 'Trouvez maintenant',
    viewAll: 'Tout voir',
    substitutionButtonLabel: 'Personnalisez avec l’IA'
  }
}
